import { TECHNICAL_SKILLS } from "../constants/Skills";

const Skills = () => {
    const skillCategories = [
        {
            title: "Application development",
            description: "Languages and frameworks for backend services and modern web interfaces.",
            data: [...TECHNICAL_SKILLS["Programming & Frameworks"], ...TECHNICAL_SKILLS["Markup & Frontend"]]
        },
        {
            title: "Data & distributed systems",
            description: "Relational data, service messaging, and the tools to understand system behavior.",
            data: [...TECHNICAL_SKILLS["Databases"], ...TECHNICAL_SKILLS["Distributed Systems & Observability"]]
        },
        {
            title: "Cloud & delivery",
            description: "Cloud services, containers, and automation for shipping software.",
            data: [...TECHNICAL_SKILLS["Cloud & Serverless"], ...TECHNICAL_SKILLS["DevOps & Automation"]]
        },
        {
            title: "Developer workflow",
            description: "Version control platforms for collaborative software development.",
            data: TECHNICAL_SKILLS["Version Control"]
        }
    ];
    return (
        <section id="skills" className="px-4 py-16 transition-colors duration-300 sm:px-6 sm:py-20 lg:px-8 lg:py-28 bg-gradient-to-b from-white to-slate-50 dark:from-slate-900 dark:to-slate-950">
            <div className="mx-auto max-w-6xl">
                <header className="mb-10 max-w-3xl sm:mb-12">
                    <p className="mb-3 text-sm font-bold uppercase tracking-wide text-blue-600 dark:text-blue-400">
                        Capabilities
                    </p>
                    <h1 className="mb-5 text-4xl font-bold text-slate-900 dark:text-white sm:text-5xl md:text-6xl">
                        Skills
                    </h1>
                    <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300 sm:text-xl">
                        I build across the software lifecycle, from application code and data to cloud delivery and system observability.
                    </p>
                </header>

                <div className="grid gap-5 md:grid-cols-2">
                    {skillCategories.map((category) => (
                        <section key={category.title} className="rounded-lg border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-800 sm:p-8">
                            <div className="mb-3 flex items-baseline justify-between gap-3">
                                <h2 className="text-2xl font-bold leading-tight text-slate-950 dark:text-white sm:text-3xl">
                                    {category.title}
                                </h2>
                                <span className="shrink-0 text-xs font-medium text-slate-500 dark:text-slate-400">
                                    {category.data.length}
                                </span>
                            </div>
                            <p className="mb-5 text-sm leading-relaxed text-slate-600 dark:text-slate-400 sm:text-base">
                                {category.description}
                            </p>
                            <ul className="grid grid-cols-2 gap-x-3 gap-y-3">
                                {category.data.map((item) => (
                                    <li
                                        key={item.toolTip}
                                        className="flex min-h-10 items-center gap-2.5 text-base font-semibold text-slate-800 dark:text-slate-100"
                                    >
                                        <span aria-hidden="true" className="flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden text-blue-600 [&>svg]:h-5 [&>svg]:w-5 dark:text-blue-300">
                                            {item.label}
                                        </span>
                                        <span className="min-w-0 break-words leading-snug">{item.toolTip}</span>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;